module.exports = __webpack_public_path__ + "static/img/金币弹框.889993d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plaza/score/金币弹框.png
// module id = u/3n
// module chunks = 42